/*****************************************************************
* Write How I Spend - Charts js here
 *****************************************************************/
let Chart = require('chart.js');
let ChartDataLabels = require('chartjs-plugin-datalabels');
let config = window.MvpFE.globalConfiguration.howISpend; // configure the color codes.
let dataChart = window.dataHowISpendCharts;//json data


//Chart Data Labels
let dataLabels = {
    color: config.catogriesBackgroundColor,
    anchor: 'end',
    align: 'top',
    offset: 0,
    formatter: function (value) {
        //Include a dollar sign 
        if (typeof value !== "undefined") {
            return '$' + value.toLocaleString();
        }
        else {
            return '$' + 1.00;
        }
    },
};

//Gobal Variables
let categoriesChart, howISpendChartdata; // Declare categories chart instance and chart data 
let categoryCode = "",totaltransactions; // Category code and total transaction of the period
let elementIndex, indexOfSelectedBar;//Index of selected and clicked bar index
let monthlyChart, labels; //Declare monthly chart instance and data labels
let  data, code,period; //Declare chart data, category code and year 
//Declare Array to store the bar background colors.
const barColors = [];
let toggleIndex = ""; //Declare for bar toggle to set the index
if (!window.MvpFE.howISpend) {
    window.MvpFE.howISpend = {}
}
//Chart Axis's
let scales = {
    x: {
        ticks: {
            font: {
                size: config.size,
            },
            color: config.dataLabelsColor,
        },
        grid: {
            display: false
        }
    },
    y: {
        display: false,
    }
};
//Chart legend
let plugins = {
    legend: {
        display: false,
    },
    tooltip: {
        enabled: true,
    },

};

function setContainerWidth(howISpendDataCatgories) {
    let isDesktop = $(window).width() >= 768;
    let containerWidth;
    const barWidth = 110;
    const contentContainerWidth = $('.how-i-spend').width();
    let maxBarNum = isDesktop ? Math.floor(contentContainerWidth / barWidth) : 10;

    if (howISpendDataCatgories) {
        let Categorycount = howISpendDataCatgories.length;
        if (Categorycount == 0) {
            containerWidth = barWidth * maxBarNum;
        } else {
            if (isDesktop && Categorycount > maxBarNum) {
                containerWidth = '100%'; 
            } else {
                containerWidth = barWidth * Categorycount;
            }
        }
    } else {
        containerWidth = barWidth * maxBarNum;
    }

    $(".how-i-spend-chart-container").css('width', containerWidth);
}
function setContainerHeight(howISpendDataCatgories) {
    let hasData = false;
    for (let i = 0; i < howISpendDataCatgories.length; i++) {
        if (howISpendDataCatgories[i].data != 0) {
            hasData = true;
            break;
        }
    }
    if (hasData) {
        //set back the height, if categories data
        $(".how-i-spend-chart-container").css('height', '200px');
        //enable datagrid row click Event ,if categories data
        $('#tblcategories tbody tr').css('pointer-events', '');
    } else {
        //set and decrease the height, if there is no categories data
        $(".how-i-spend-chart-container").css('height', '100px');
        //disable the datagrid row click Event,if there is no categories data
        $('#tblcategories tbody tr').css('pointer-events', 'none');
    }
}

function DisplayChart(dataChart, callback) {
    if (dataChart != null) {
        // Map and set all categories
        labels = dataChart.howISpendDataCatgories.map(function (e) {
            return e.label;
        });//labels
        data = dataChart.howISpendDataCatgories.map(function (e) {
            return e.data;
        });//data values
        code = dataChart.howISpendDataCatgories.map(function (e) {
            return e.code;
        });//categories code
        totaltransactions = dataChart.howISpendDataCatgories.map(function (e) {
            return e.totaltransactions;
        });// category total transactions  
        period = dataChart.howISpendDataCatgories.map(function (e) {
            return e.period;
        });//year

        setContainerWidth(dataChart.howISpendDataCatgories);
        setContainerHeight(dataChart.howISpendDataCatgories)
    }
   
    //chart data
    howISpendChartdata = {
        labels: labels,
        datasets: [{
            data: data,
            backgroundColor: config.catogriesBackgroundColor,
            borderColor: config.catogriesBorderColor,
            borderWidth: config.barWidth,
            borderRadius: config.barRadius,
            borderSkipped: 'false',
            datalabels: dataLabels
        }]
    }

    let ctx = document.getElementById('how_i_spend_canvas');//canvas
    if (ctx) { // DOM element is present and not null
        if (categoriesChart) categoriesChart.destroy();
        if (monthlyChart) monthlyChart.destroy();
        categoriesChart = new Chart(ctx.getContext('2d'), {
            type: 'bar',
            data: howISpendChartdata,
            // Chart pulgins & Options
            plugins: [ChartDataLabels],
            options: {
                responsive: true,
                layout: {
                    padding: {
                        top: config.paddingTop,
                    }
                },
                maintainAspectRatio: false,
                aspectRatio: 2,
                plugins: plugins,
                onHover: (event, chartElement) => {
                    event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                },
                scales: scales,
                onClick: function (evt, element) {
                    if (element.length > 0) {
                        categoryCode = code[element[0].index];
                        period = period[element[0].index];
                        let transactions = totaltransactions[element[0].index];
                        $("#SelectedCategoryYear").val(period);//set  category Year in hidden Variable
                        if (callback) {
                            callback(categoryCode, transactions);
                        } else {
                            DisplayCategoryChart(dataChart.howISpendDataCatgory, callback);
                        }
                    }
                },
            }

        });


    }
    //}

}
function DisplayCategoryChart(howISpendDataCatgory, callback) {
    //check if instance is undefined
    if (typeof categoriesChart == "undefined") {
        categoriesChart = Chart.getChart("how_i_spend_canvas"); // <canvas> id
    }
    // get no of month data bars
    const bars = Array.from({ length: 12 }, (e, i) => {
        return new Date(null, i + 1, null).toLocaleDateString(config.LocaleDateString, { month: "long" });
    })
    //months labels and data
    labels = howISpendDataCatgory.map(function (evt) {
        return evt.label;
    });
    data = howISpendDataCatgory.map(function (evt) {
        return evt.data;
    });
    period = howISpendDataCatgory.map(function (evt) {
        return evt.period; //year of Selected category 
    });
    code = howISpendDataCatgory.map(function (evt) {
        return evt.code; // code of Selected category 
    });
    let highlightedMonth = howISpendDataCatgory.map(function (evt) {
        return evt.month; // month of Selected category
    });
    let selectedCategoryName = howISpendDataCatgory.map(function (evt) {
        return evt.name; // name of Selected category
    });

    setContainerWidth(howISpendDataCatgory);
    //set the category heading
    let categoryheading;
    if (selectedCategoryName != null && selectedCategoryName.length > 0) {
        categoryheading = selectedCategoryName[0];
        if (categoryheading.indexOf(',') != -1) {   // Category heading label text , if have comma(,)
            categoryheading = categoryheading.toString().replace(',', '');
        }
    }
    if (howISpendDataCatgory != null && howISpendDataCatgory != "") {
        //Top Spend of Month
        const Datalist = howISpendDataCatgory.map(item => item.data)
        let maxCategoryDataValue = Math.max.apply(null, Datalist);
        let filter = { data: maxCategoryDataValue };
        let topSpendDeatils = howISpendDataCatgory.filter(function (item) {
            for (let key in filter) {
                if (item[key] === undefined || item[key] != filter[key])
                    return false;
            }
            return true;
        });

        // check if there is previous selection
        let previousSelection = barColors.includes(config.selectedColor);
        if (previousSelection) {
            let PreIndex = barColors.indexOf(config.selectedColor);
            barColors[PreIndex] = config.unSelectedColor;
        }
        let spendMonth; let selectedDetails;
        //Highlight the particular Month on Filter month selection 
        bars.forEach((elem, monthIndex) => {
            barColors.push(config.unSelectedColor);
            selectedDetails = howISpendDataCatgory.filter(function (monthitem) {
                return monthitem.label == highlightedMonth[monthIndex];//set the index of filter month
            });
        });

        //set the Spend month and amount of particular month on on Filter month selection 
        if (selectedDetails.length > 0 && selectedDetails[0].month != "All") {
            let filterDetails = howISpendDataCatgory.filter(function (item) {
                return item.label == selectedDetails[0].month;
            });
            spendMonth = filterDetails[0].label;
        } else {
            //set Top Spend of category
            spendMonth = topSpendDeatils.map(item => item.label)
        }
        //set labels & data
        categoriesChart.data.labels = labels
        categoriesChart.data.datasets[0].data = data;
        // Populate barcolors array with unselected  colors from global config
        let spendMonthIndex;
        bars.forEach((elem, barIndex) => {
            barColors.push(config.unSelectedColor);
            if (labels[barIndex] == spendMonth) {
                spendMonthIndex = barIndex;//set the index of the top spend month
                return true;
            }
        });
        //Set colors
        categoriesChart.data.datasets[0].backgroundColor = barColors;
        categoriesChart.data.datasets[0].borderColor = barColors;
        //Check and set top spending higlighted bar with amount
        if (categoryheading != "" && maxCategoryDataValue > 0) {
            categoriesChart.data.datasets[0].backgroundColor[spendMonthIndex] = config.selectedColor;
            //Set category heading label text if Top Spend category.
            $('.how-i-spend-category-heading').text(categoryheading + ' - ' + spendMonth + ' ' + period[0]);
        }
        else {
            //Set category heading label text, if not top spend category .
            $('.how-i-spend-category-heading').text(categoryheading + ' - ' + period[0]);
        }
        categoriesChart.update();
        // Whether chart appears anywhere in the chart object.
        if (categoriesChart instanceof Chart) {
            //replace current canvas to display new chart.
            $('#how_i_spend_canvas').replaceWith($('<canvas id="howISpendMonthlyCanvas"></canvas>'));
        }
        // JS - Destroy exiting Chart Instance to reuse <canvas> element on search
        let chartStatus = Chart.getChart("howISpendMonthlyCanvas"); // <canvas> id
        if (chartStatus != undefined) {
            chartStatus.destroy();
        }

        // Code to draw Chart
        if (monthlyChart) monthlyChart.destroy();
        monthlyChart = new Chart(document.getElementById('howISpendMonthlyCanvas').getContext('2d'), {
            type: 'bar',
            data: howISpendChartdata,
            plugins: [ChartDataLabels],
            options: {
                responsive: true,
                layout: {
                    padding: {
                        top: config.paddingTop,
                    }
                },
                maintainAspectRatio: false,
                aspectRatio: 2,
                plugins: plugins,
                scales: scales,
                onHover: (event, chartElement) => {
                    event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                },
                onClick: function (e, activeElements) {
                    if (activeElements.length > 0) { // check the element is selected
                        monthlyChart.options.animation.colors = false;
                        elementIndex = activeElements[0].index;
                        let selectedMonthLabel = monthlyChart.data.labels[elementIndex];
                        let selectedBarYear = period[elementIndex];
                        let selectedCategoryCode = code[elementIndex];
                        let CategoryName = selectedCategoryName[elementIndex];
                        indexOfSelectedBar = barColors.indexOf(config.selectedColor);
                        let $toggle = $(this);
                        toggleIndex = $("#barToggle").val(); //hidden field
                        // Check category is empty then set hidden field value
                        if (categoryCode == "" && categoryCode.length == 0) {
                            categoryCode = $("#SelectedCategoryCode").val();
                        }
                        if (callback) {
                            callback(selectedCategoryCode, selectedMonthLabel, selectedBarYear);
                        }
                        DislayMonthDetails(selectedCategoryCode, selectedMonthLabel, selectedBarYear, callback, CategoryName,$toggle)

                    }
                }
            },
        });
    }
}

function DislayMonthDetails(categoryCode, barMonth, barYear, callback, categoryLabel,$toggle) {
    let setBackAllmonths = "All"// set the All month of the selected period
    // Category heading label text , if have comma(,)
    if (categoryLabel.indexOf(',') != -1) {
        categoryLabel = categoryLabel.toString().replace(',', '');
    }
    if (indexOfSelectedBar !== -1) {
        //Set colors on bar toggle
        if (!$toggle.data('clicked')) {
            // Check if the highlighed bar and set color on first click 
            let highlightedMonthColor = monthlyChart.data.datasets[0].backgroundColor[elementIndex];
            let initialselection = barColors.includes(config.selectedColor);
            //if selectedColor and Highlighed bar is clicked on first.
            //set  color of clicked bar and set back all months of selected category
            if (initialselection && highlightedMonthColor == config.selectedColor) {
                barColors[indexOfSelectedBar] = config.unSelectedColor;
                monthlyChart.data.datasets[0].backgroundColor = config.catogriesBackgroundColor;
                monthlyChart.data.datasets[0].borderColor = config.catogriesBackgroundColor;
                monthlyChart.update();
                //set back all months of selected category
                if (callback) {
                    callback(categoryCode, setBackAllmonths, barYear);
                }
                $('.how-i-spend-category-heading').text(categoryLabel + ' - ' + barYear);
            } else {
                barColors[indexOfSelectedBar] = config.unSelectedColor;
                monthlyChart.data.datasets[0].backgroundColor = barColors;
                monthlyChart.data.datasets[0].backgroundColor[elementIndex] = config.selectedColor;
                monthlyChart.data.datasets[0].borderColor = barColors;
                monthlyChart.data.datasets[0].borderColor[elementIndex] = config.selectedColor;
                monthlyChart.update();
                // //Setback category heading label text with selected month,on first click 
                $('.how-i-spend-category-heading').text(categoryLabel + ' - ' + barMonth + ' ' + barYear);
            }
        }
        else if (toggleIndex == elementIndex) { //Check and set color,if same month Bar of chart is clicked again 
            barColors[indexOfSelectedBar] = config.unSelectedColor;
            monthlyChart.data.datasets[0].backgroundColor = config.catogriesBackgroundColor;
            monthlyChart.data.datasets[0].borderColor = config.catogriesBackgroundColor;
            monthlyChart.update();
            //set back all months of selected category
            if (callback) {
                callback(categoryCode, setBackAllmonths, barYear);
            }
            //Setback category heading label text with selected month,if toggle
            $('.how-i-spend-category-heading').text(categoryLabel + ' - ' + barYear);
        }
        else if (toggleIndex != elementIndex) { //check set color,if next bar clicked 
            barColors[indexOfSelectedBar] = config.unSelectedColor;
            monthlyChart.data.datasets[0].backgroundColor = barColors;
            monthlyChart.data.datasets[0].backgroundColor[elementIndex] = config.selectedColor;
            monthlyChart.data.datasets[0].borderColor = barColors;
            monthlyChart.data.datasets[0].borderColor[elementIndex] = config.selectedColor;
            monthlyChart.update();
            //Setback category heading label text with selected month,if next bar click 
            $('.how-i-spend-category-heading').text(categoryLabel + ' - ' + barMonth + ' ' + barYear);
        }
    }
    else { //Setback the colors, and highligt selected Month
        monthlyChart.data.datasets[0].backgroundColor = barColors;
        monthlyChart.data.datasets[0].backgroundColor[elementIndex] = config.selectedColor;
        monthlyChart.data.datasets[0].borderColor = barColors;
        monthlyChart.data.datasets[0].borderColor[elementIndex] = config.selectedColor;
        monthlyChart.update();
        // Setback category heading label text with selected month, if not toggle. 
        $('.how-i-spend-category-heading').text(categoryLabel + ' - ' + barMonth + ' ' + barYear);
    }
    //Store the current index value to hidden field 
    document.getElementById("barToggle").value = elementIndex
    $toggle.data('clicked', true);//make toggle clicked
}

window.MvpFE.howISpend.DisplayChart = DisplayChart;
window.MvpFE.howISpend.DisplayCategoryChart = DisplayCategoryChart;
window.MvpFE.howISpend.DislayMonthDetails = DislayMonthDetails;
$(function () {
    DisplayChart(dataChart)
});
